import { jsonApiClient } from 'shared/model';
import { LocationSetting, Setting } from '../@types';

const api = jsonApiClient('Settings');

export const getSettings = (signal?: AbortSignal) => api.get<Setting[]>(undefined, { signal });
export const getLocationSettings = (location_id: string, signal?: AbortSignal) => api.get<LocationSetting[]>(location_id, { signal });
export const postLocationSettings = (locationSettings: LocationSetting[]) => api.post<LocationSetting[]>(undefined, locationSettings);
